var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'page-view',
    _vm.full ? 'flex-expend' : '',
    _vm.full && _vm.direct ? 'flex-' + (_vm.direct == 'horizontal' ? 'col' : 'row') : '',
  ]},[_c('div',{staticClass:"global-back"},[(_vm.canBack && !_vm.embeded)?_c('el-button',{staticClass:"button-segment",attrs:{"icon":_vm.hooks && _vm.hooks.style && _vm.hooks.style.icon
          ? _vm.hooks.style.icon
          : 'el-icon-back',"size":"small","plain":"","type":_vm.hooks && _vm.hooks.style ? _vm.hooks.style.type : null},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.hooks && _vm.hooks.style ? _vm.hooks.style.txt : "返回"))]):_vm._e(),_vm._t("pending-buttons")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }